const KEY = 'selectedPatientId';

export default {
  get() {
    const raw = sessionStorage.getItem(KEY);
    return raw ? Number(raw) : null;
  },
  set(patientId) {
    if (patientId === null || patientId === undefined) {
      sessionStorage.removeItem(KEY);
    } else {
      sessionStorage.setItem(KEY, String(patientId));
    }
  },
  clear() {
    sessionStorage.removeItem(KEY);
  }
};



// WEBPACK FOOTER //
// ./src/brand/health/store/selectedPatient.js